import noop from '@gaia/util/noop/action'
import index from './action/index'
import search from './action/search'

export default {
  index,
  search,
  demo: noop,
}
